import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import BookMarkTable from "../../components/tables/BookMarkTable"
import NotesTable from "../../components/tables/notesTable";
import { api } from "../../utils/apiClient";
import LoadingShimmer from "../../utils/LoadingShimmer";
import GlobalFilter from "../../components/filters/GlobalFilter";
import { Icon } from "@iconify/react/dist/iconify.js";
import BookmarkViewModal from "../../components/modal/BookmarkViewModal";
import RemaindersTable from "../../components/tables/remaindersTable";




let searchTimeout;

const Remainders = () => {
      const [bookMark, setBookMark] = useState([]);
      const [loading, setLoading] = useState(true);

      //pagination
      const [page, setPage] = useState(1);
      const [limit] = useState(10);
      const [totalPages, setTotalPages] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
      //sort
      const [sort, setSort] = useState("created_at");
      const [order, setOrder] = useState("desc");
      //search
      const [search, setSearch] = useState("");
      const [debouncedSearch, setDebouncedSearch] = useState("");
      const [dateFilters, setDateFilters] = useState({ startDate: "", endDate: "" });
      const [selectedDates, setSelectedDates] = useState([]);
      const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
      //const navigate = useNavigate();
      const [viewModalOpen, setViewModalOpen] = useState(false);
      const [selectedBookMark, setSelectedBookMark] = useState(null);
      const [entriesPerPage, setEntriesPerPage] = useState(10);
      //const [activeTab, setActiveTab] = useState("new");

      const handleView = (bookMark) => {
            setSelectedBookMark(bookMark);
            setViewModalOpen(true);
      };

      useEffect(() => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                  setDebouncedSearch(search);
                  setPage(1);
            }, 1000);
            return () => clearTimeout(searchTimeout);
      }, [search]);

      const fetchBookMark = async () => {
            try {
                  setLoading(true);

                  const response = await api.get("/remainders", {
                        params: {
                              page,
                              limit: entriesPerPage,
                              sort,
                              order,
                              search: debouncedSearch?.trim() || "",
                              //status: activeTab,
                              startDate: dateFilters.startDate || undefined,
                              endDate: dateFilters.endDate || undefined,
                        }
                  });

                  console.log("API Response for remainders:", response.data);

                  setBookMark(response.data.data || []);
                  setTotalPages(response.data.pagination.totalPages || 1);
                  setTotalEntries(response.data.pagination.total || 0);

            } catch (error) {
                  console.error("Error fetching bookMark:", error);
            } finally {
                  setLoading(false);
            }
      };

      useEffect(() => {
            fetchBookMark();
      }, [page, entriesPerPage, sort, order, debouncedSearch, dateFilters]);


      const handleClearFilters = () => {
            setDateFilters({ startDate: "", endDate: "" }); // reset date filters
            setSelectedDates([]); // reset UI calendar selection
            setPage(1); // reset pagination
      };

      //date helper
      const formatLocalDate = (date) => {
            if (!date) return "";
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}`;
      };

      const handleDateFilter = ({ startDate, endDate, rawDates, status }) => {

            setSelectedDates(rawDates);

            const formattedStart = formatLocalDate(startDate);
            const formattedEnd = formatLocalDate(endDate);

            //console.log("Formatted Start Date:", formattedStart);
            //console.log("Formatted End Date:", formattedEnd);

            setDateFilters({
                  startDate: formattedStart,
                  endDate: formattedEnd,
                  status: status ? status.value : null,
            });
            setPage(1); // reset page
      };



      return (
            <>
                  <div className="page-header-row">
                        {/* Breadcrumb */}
                        <Breadcrumb title="Remainders Management" />
                        <div className="filter-wrapper">

                              <div className="d-flex align-items-center gap-3">
                                    {/* Refresh Icon */}
                                    <Icon
                                          icon="mdi:refresh"
                                          width="26"
                                          height="26"
                                          className={`ms-2 d-inline-flex d-md-none mobile-refresh-icon ${loading ? "spin" : ""}`}
                                          onClick={fetchBookMark}
                                    />
                                    {/* Filter toggle button */}
                                    <div className="filter-btn-wrapper">
                                          <button
                                                className="filter-btn"
                                                onClick={() => setMobileFilterOpen(!mobileFilterOpen)}
                                          >
                                                {/* <Icon icon="mdi:filter" width="24" height="24" /> */}
                                                <img src="assets\images\filter.png" alt="" className="filter-icon" />
                                          </button>
                                    </div>
                              </div>
                        </div>

                  </div>
                  {/* Filter panel (toggle on mobile, always visible on desktop) */}
                  <div className={`filter-panel ${mobileFilterOpen ? "open" : ""}`}>
                        <GlobalFilter
                              showDateRange={true}
                              onSearch={handleDateFilter}
                              onClear={handleClearFilters}
                              selectedDates={selectedDates}
                        />
                  </div>

                  {loading ? (
                        < LoadingShimmer
                              columns={8}
                              rows={6}
                              avatarColumnIndex={2}
                              actionColumnIndex={7}
                        />
                  ) : (
                        <RemaindersTable
                              bookMark={bookMark}
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              sort={sort}
                              order={order}
                              setSort={setSort}
                              setOrder={setOrder}
                              search={search}
                              setSearch={setSearch}
                              onView={handleView}
                              fetchBookMark={fetchBookMark}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  )}

                  <BookmarkViewModal
                        open={viewModalOpen}
                        onClose={() => setViewModalOpen(false)}
                        data={selectedBookMark}
                  />


            </>
      );
};

export default Remainders;
